import { Component, signal } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { NavbarComponent } from './common/navbar/navbar';
import { LoginNavbar } from './common/login-navbar/login-navbar';
import { TeacherRegisterNavbar } from './common/teacher-register-navbar/teacher-register-navbar';
import { FooterComponent } from './common/footer/footer';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { RouteTrackerService } from './services/route-tracker.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NavbarComponent,
    LoginNavbar,
    TeacherRegisterNavbar,
    FooterComponent,
    CommonModule
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class AppComponent {

  private hiddenGlobalChromeRoutes = [
    '/parentpanel',
    '/teacherpanel',
    '/student'
  ];

  private noChromeRoutes = [
    '/login-teacher'
  ];

  showGlobalNav = signal(true);
  showGlobalFooter = signal(true);
  showLoginNav = signal(false);
  showTeacherRegisterNav = signal(false);

  constructor(private router: Router, private routeTracker: RouteTrackerService) {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: any) => {

        const url = e.urlAfterRedirects.toLowerCase();

        const isDashboard = this.hiddenGlobalChromeRoutes.some(r =>
          url.startsWith(r)
        );

        const currentRoute = this.router.routerState.root;

        let hideGlobalChrome = false;

        currentRoute.children.forEach(route => {
          if (route.snapshot.data['hideGlobalChrome']) {
            hideGlobalChrome = true;
          }
        });
        // Teacher registration is detected by the query string, since
        // it shares the /registration route with student sign-up.
        const isTeacherRegisterPage =
          url.startsWith('/registration') && url.includes('role=teacher');

        const isAuthPage =
          !isTeacherRegisterPage && (
            url.startsWith('/login') ||
            url.startsWith('/registration') ||
            url.startsWith('/forgot-password') ||
            url.startsWith('/resetpassword')
          );

        const isNoChromePage = this.noChromeRoutes.some(r =>
          url.startsWith(r)
        );

        this.showGlobalNav.set( !hideGlobalChrome && !isDashboard && !isAuthPage && !isTeacherRegisterPage && !isNoChromePage );
        this.showLoginNav.set( !hideGlobalChrome && isAuthPage && !isNoChromePage );
        this.showTeacherRegisterNav.set( !hideGlobalChrome && isTeacherRegisterPage );
        this.showGlobalFooter.set( !hideGlobalChrome && !isDashboard && !isAuthPage && !isTeacherRegisterPage && !isNoChromePage );
      });
  }
}